/**
 * @desc 统一门户根据登录用户获取报警消息列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.AlertMessageSearchPortalRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.AlertMessagePortalResponse>>> {
  return defHttp.post({
    url: '/portal/alert/message/search',
    data,
  });
}

export function mock(
  data: defs.AlertMessageSearchPortalRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.AlertMessagePortalResponse>>> {
  return defHttp.post({
    url: '/mock/portal/alert/message/search',
    data,
  });
}
